export enum ModalType {
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
}
